import { keyBy } from 'lodash';

export default function decorateSyncsWithVersionSettings({ syncs, postInsertIdentitySyncs }) {
  const byName = keyBy(postInsertIdentitySyncs ?? [], row => row.identity_sync.name);

  return syncs.map(sync => {
    const persisted = byName[sync.name];
    return {
      ...sync,
      versionSettings: {
        settingsVersion: persisted?.settingsVersion ?? 1,
        shouldResyncOnSettingsChange: persisted?.enableResyncOnSettingsChange === true,
      },
    };
  });
}
